function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) {
        return;
    }
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
                break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i['return'] != null)
                _i['return']();
        } finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr))
        return arr;
}
import window from 'global/window';
import * as Dom from '@emav-util/dom';
import * as Events from '@emav-util/events';
import * as Fn from '@emav-util/fn';
import * as Obj from '@emav-util/obj';
import EventTarget from '../event-target';
var isEvented = function isEvented(object) {
    return object instanceof EventTarget || !!object.eventBusEl_ && [
        'on',
        'one',
        'off',
        'trigger'
    ].every(function (k) {
        return typeof object[k] === 'function';
    });
};
var addEventedCallback = function addEventedCallback(target, callback) {
    if (isEvented(target)) {
        callback();
    } else {
        if (!target.eventedCallbacks) {
            target.eventedCallbacks = [];
        }
        target.eventedCallbacks.push(callback);
    }
};
var isValidEventType = function isValidEventType(type) {
    return typeof type === 'string' && /\S/.test(type) || Array.isArray(type) && !!type.length;
};
var validateTarget = function validateTarget(target) {
    if (!target.nodeName && !isEvented(target)) {
        throw new Error('Invalid target; must be a DOM node or evented object.');
    }
};
var validateEventType = function validateEventType(type) {
    if (!isValidEventType(type)) {
        throw new Error('Invalid event type; must be a non-empty string or array.');
    }
};
var validateListener = function validateListener(listener) {
    if (typeof listener !== 'function') {
        throw new Error('Invalid listener; must be a function.');
    }
};
var normalizeListenArgs = function normalizeListenArgs(self, args) {
    var isTargetingSelf = args.length < 3 || args[0] === self || args[0] === self.eventBusEl_;
    var target;
    var type;
    var listener;
    if (isTargetingSelf) {
        target = self.eventBusEl_;
        if (args.length >= 3) {
            args.shift();
        }
        var _args = _slicedToArray(args, 2);
        type = _args[0];
        listener = _args[1];
    } else {
        var _args2 = _slicedToArray(args, 3);
        target = _args2[0];
        type = _args2[1];
        listener = _args2[2];
    }
    validateTarget(target);
    validateEventType(type);
    validateListener(listener);
    listener = Fn.bind(self, listener);
    return {
        isTargetingSelf: isTargetingSelf,
        target: target,
        type: type,
        listener: listener
    };
};
var listen = function listen(target, method, type, listener) {
    validateTarget(target);
    if (target.nodeName) {
        Events[method](target, type, listener);
    } else {
        target[method](type, listener);
    }
};
var EventedMixin = {
    on: function on() {
        var _this = this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        var _normalizeListenArgs = normalizeListenArgs(this, args), isTargetingSelf = _normalizeListenArgs.isTargetingSelf, target = _normalizeListenArgs.target, type = _normalizeListenArgs.type, listener = _normalizeListenArgs.listener;
        listen(target, 'on', type, listener);
        if (!isTargetingSelf) {
            var removeListenerOnDispose = function removeListenerOnDispose() {
                return _this.off(target, type, listener);
            };
            removeListenerOnDispose.guid = listener.guid;
            var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose() {
                return _this.off('dispose', removeListenerOnDispose);
            };
            removeRemoverOnTargetDispose.guid = listener.guid;
            listen(this, 'on', 'dispose', removeListenerOnDispose);
            listen(target, 'on', 'dispose', removeRemoverOnTargetDispose);
        }
    },
    one: function one() {
        var _this2 = this;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }
        var _normalizeListenArgs2 = normalizeListenArgs(this, args), isTargetingSelf = _normalizeListenArgs2.isTargetingSelf, target = _normalizeListenArgs2.target, type = _normalizeListenArgs2.type, listener = _normalizeListenArgs2.listener;
        if (isTargetingSelf) {
            listen(target, 'one', type, listener);
        } else {
            var wrapper = function wrapper() {
                _this2.off(target, type, wrapper);
                for (var _len3 = arguments.length, largs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    largs[_key3] = arguments[_key3];
                }
                listener.apply(null, largs);
            };
            wrapper.guid = listener.guid;
            listen(target, 'one', type, wrapper);
        }
    },
    off: function off(targetOrType, typeOrListener, listener) {
        if (!targetOrType || isValidEventType(targetOrType)) {
            Events.off(this.eventBusEl_, targetOrType, typeOrListener);
        } else {
            var target = targetOrType;
            var type = typeOrListener;
            validateTarget(target);
            validateEventType(type);
            validateListener(listener);
            listener = Fn.bind(this, listener);
            this.off('dispose', listener);
            if (target.nodeName) {
                Events.off(target, type, listener);
                Events.off(target, 'dispose', listener);
            } else if (isEvented(target)) {
                target.off(type, listener);
                target.off('dispose', listener);
            }
        }
    },
    trigger: function trigger(event, hash) {
        return Events.trigger(this.eventBusEl_, event, hash);
    }
};
function evented(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var eventBusKey = options.eventBusKey;
    if (eventBusKey) {
        if (!target[eventBusKey].nodeName) {
            throw new Error('The eventBusKey "'.concat(eventBusKey, '" does not refer to an element.'));
        }
        target.eventBusEl_ = target[eventBusKey];
    } else {
        target.eventBusEl_ = Dom.createEl('span', { className: 'emav-event-bus' });
    }
    Obj.assign(target, EventedMixin);
    if (target.eventedCallbacks) {
        target.eventedCallbacks.forEach(function (callback) {
            callback();
        });
    }
    target.on('dispose', function () {
        target.off();
        window.setTimeout(function () {
            target.eventBusEl_ = null;
        }, 0);
    });
    return target;
}
export default evented;
export {
    isEvented
};
export {
    addEventedCallback
};